const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
// @utilities
const { on } = require('commonsUtilities/scrollUtils');
const storage = require('utilities/storage');
// @components
const ChatCollapsed = require('./collapsed/ChatCollapsed');
const ChatExpanded = require('./expanded/ChatExpanded');
//@constants
const {
    CHAT_WINDOW_STATUS: {
        COLLAPSED,
        EXPANDED
    },
    CHAT_POSITIONS
} = require('constants/chat');
const {
    CHAT_CONVERSATION_STATUS: {
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE,
        POLLING_TIME
    }
} = require('constants/chat');
const { TABLET_MAX_WIDTH } = require('constants/index');

require('./Chat.scss');

class Chat extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chatButtonPosition: CHAT_POSITIONS.ALONE,
            updateInterval: null
        };

        this.handleChatPositioning = this.handleChatPositioning.bind(this);
    }

    componentDidMount() {
        const { retrieveMessagesHistory } = this.props;
        const cId = storage.localStorage.get('chatId') || null;
        const chatData = storage.localStorage.get('chatData') || null;
        on(undefined, this.handleChatPositioning);
        window.addEventListener('resize', this.handleChatPositioning);
        document.body.addEventListener("DOMSubtreeModified", this.handleChatPositioning);
        if (cId !== null) {
            retrieveMessagesHistory(atob(cId), chatData);
        }
    }

    componentWillReceiveProps(nextProps) {
        const {
            retrieveMessages,
            chatWindowStatus,
            setTimer,
            msgReceiveFail,
            conversationStatus,
            resetTimer,
            retrieveMessagesInterval
        } = this.props;
        const { updateInterval } = this.state;
        if (nextProps.retrieveMessagesInterval) {
            updateInterval && clearInterval(updateInterval);
            this.setState({ updateInterval: setInterval(retrieveMessages, retrieveMessagesInterval) });
        }
        if (chatWindowStatus !== COLLAPSED && chatWindowStatus !== nextProps.chatWindowStatus) {
            this.props.chatAvailabilityStatus();
        }
        if (nextProps.msgReceiveFail && nextProps.msgReceiveFail !== msgReceiveFail) {
            setTimer();
            this.startTimer();
        }
        if (!msgReceiveFail && conversationStatus === ACTIVE && !nextProps.msgReceiveFail) {
            clearInterval(this.startPollingTimer);
            resetTimer();
        }
    }

    startTimer() {
        const { resetTimer } = this.props;
        let time = POLLING_TIME;
        this.startPollingTimer = setInterval(function () {
            if (time > 0) {
                time -= 1;
            } else if (time === 0) {
                storage.localStorage.remove('chatData');
                storage.localStorage.remove('chatId');
                clearInterval(this.startPollingTimer);
                resetTimer();
            }
        }, 1000);
    }


    handleChatPositioning() {
        const smallViewport = window.innerWidth <= TABLET_MAX_WIDTH;
        const windowHeight = window.innerHeight;
        const footerRect = document.getElementsByClassName('footer') && document.getElementsByClassName('footer')[0].getBoundingClientRect();
        const footerVisibleOnScreen = footerRect.top <= windowHeight;
        const backToTopElement = document.getElementById('ok-back-to-top--container');
        let chatButtonPosition = CHAT_POSITIONS.ALONE;

        if (backToTopElement && backToTopElement.style.display === 'block') {
            if (!smallViewport) {
                chatButtonPosition = backToTopElement.classList.contains('ok-back-to-top--footer-overlap') ?
                    CHAT_POSITIONS.WITH_FOOTER_AND_BACK_TO_TOP : // if back to top & footer
                    CHAT_POSITIONS.WITH_BACK_TO_TOP; // if back to top but no footer
            } else if (smallViewport && footerVisibleOnScreen) {
                chatButtonPosition = CHAT_POSITIONS.WITH_FOOTER_SMALL_VIEWPORT;// small viewpor footer and back to top
            }
        } else {
            if (!smallViewport && footerVisibleOnScreen) {  //if footer is close and is not in small viewport
                chatButtonPosition = CHAT_POSITIONS.WITH_FOOTER;
            } else if (smallViewport && footerVisibleOnScreen) { //if footer is close and is in small viewport
                chatButtonPosition = CHAT_POSITIONS.WITH_FOOTER_SMALL_VIEWPORT;
            }
        }

        this.state.chatButtonPosition !== chatButtonPosition && this.setState({
            chatButtonPosition
        });
    }

    renderChatCollapsed() {
        const {
            conversationStatus,
            startConversation,
            toggleWindow,
            isChatAvailable,
            chatAvailabilityStatusData
        } = this.props;
        return (
            <ChatCollapsed
                conversationStatus={conversationStatus}
                isChatAvailable={isChatAvailable}
                startConversation={startConversation}
                toggleWindow={toggleWindow}
                chatAvailabilityStatusData={chatAvailabilityStatusData}
            />
        );
    }

    renderChatExpanded() {
        const {
            conversationStatus,
            toggleWindow,
            chatAvailabilityStatusData
        } = this.props;
        return (
            <ChatExpanded
                conversationStatus={conversationStatus}
                toggleWindow={toggleWindow}
                chatAvailabilityStatusData={chatAvailabilityStatusData}
            />
        );
    }

    render() {
        const { chatWindowStatus } = this.props;
        const { chatButtonPosition } = this.state;
        const wrapperClasses = classNames('chat-wrapper', {
            'chat-wrapper--alone': chatButtonPosition === CHAT_POSITIONS.ALONE,
            'chat-wrapper--above-back-to-top': chatButtonPosition === CHAT_POSITIONS.WITH_BACK_TO_TOP,
            'chat-wrapper--above-back-to-top-overlap': chatButtonPosition === CHAT_POSITIONS.WITH_FOOTER_AND_BACK_TO_TOP,
            'chat-wrapper--overlaps-footer': chatButtonPosition === CHAT_POSITIONS.WITH_FOOTER,
            'chat-wrapper--overlaps-footer-responsive': chatButtonPosition === CHAT_POSITIONS.WITH_FOOTER_SMALL_VIEWPORT
        });
        const innerComponent = chatWindowStatus === COLLAPSED ? this.renderChatCollapsed() : this.renderChatExpanded();
        return (
            <div className={wrapperClasses}>{innerComponent}</div>
        );
    }
}

Chat.propTypes = {
    chatAvailabilityStatus: PropTypes.func.isRequired,
    chatAvailabilityStatusData: PropTypes.object.isRequired,
    chatWindowStatus: PropTypes.oneOf([
        COLLAPSED,
        EXPANDED
    ]),
    conversationStatus: PropTypes.oneOf([
        ACTIVE,
        CONNECTING,
        DISCONNECTED,
        ERROR,
        INACTIVE
    ]).isRequired,
    endConversation: PropTypes.func.isRequired,
    isChatAvailable: PropTypes.bool.isRequired,
    msgReceiveFail: PropTypes.bool,
    resetTimer: PropTypes.func.isRequired,
    retrieveMessages: PropTypes.func.isRequired,
    retrieveMessagesHistory: PropTypes.func,
    retrieveMessagesInterval: PropTypes.number,
    setTimer: PropTypes.func.isRequired,
    startConversation: PropTypes.func.isRequired,
    timer: PropTypes.bool.isRequired,
    toggleWindow: PropTypes.func.isRequired
};

module.exports = Chat;
